import React from 'react';
import { ResponsiveSwarmPlot } from '@nivo/swarmplot';
import { getRange } from './autoSize';
import { NivoTextTheme } from "./utils";


const NivoSwarmChart = ({ data, groups, customColors, yTitle='', xTitle=''}) => {
    const {min, max, range} = getRange(data.map(x=>x.value));
    const meanValue = data.reduce((acc, current) => acc + current.value, 0) / data.length;

    const getColor = (node) => {
        console.log(node, customColors);
        const id = node.id.split('-')[0];
        return customColors?.[id]
    }

    return (
        <ResponsiveSwarmPlot
            data={data}
            theme={NivoTextTheme}
            groups={groups}
            identity="id"
            value="value"
            valueFormat="#.2f"
            valueScale={{ type: 'linear', min: min, max: max, reverse: false }}
            size={{
                key: 'size',
                values: [4, 20],
                sizes: [25, 75] //   Size Range
            }}
            forceStrength={8}
            colors={getColor}
            simulationIterations={100}
              borderColor={{
                from: customColors ? 'id' : 'color',
                modifiers: [
                  [
                    'darker',
                    0.6,
                  ],
                  [
                    'opacity',
                    0.5,
                  ],
                ],
              }}
            margin={{ top: 10, right: 130, bottom: 50, left: 130 }}
            axisTop={{
                orient: 'top',
                tickSize: 10,
                tickPadding: 5,
                tickRotation: 0,
                legend: '',
                legendPosition: 'middle',
                legendOffset: -46,
                truncateTickAt: 0
            }}
            axisRight={{
                orient: 'right',
                tickSize: 10,
                tickPadding: 5,
                tickRotation: 0,
                legend: yTitle,
                legendPosition: 'middle',
                legendOffset: 76,
                truncateTickAt: 0
            }}
            axisBottom={{
                orient: 'bottom',
                tickSize: 10,
                tickPadding: 5,
                tickRotation: 0,
                legend: xTitle,
                legendPosition: 'middle',
                legendOffset: 46,
                truncateTickAt: 0
            }}
            axisLeft={{
                orient: 'left',
                tickSize: 10,
                tickPadding: 5,
                tickRotation: 0,
                legend: yTitle,
                legendPosition: 'middle',
                legendOffset: -76,
                truncateTickAt: 0
            }}
            legends={[
                {
                  anchor: 'top-right',
                  direction: 'column',
                  justify: false,
                  translateX: 130,
                  translateY: 0,
                  itemsSpacing: 0,
                  itemWidth: 250,
                  itemHeight: 20,
                  itemTextColor: '#999',
                  symbolSize: 15,
                  symbolShape: 'circle',
                  effects: [
                    {
                      on: 'hover',
                      style: {
                        itemBackground: 'rgba(0, 0, 0, .03)',
                        itemOpacity: 1,
                      },
                    },
                  ],
                },
              ]}
        />
    )
}


export default NivoSwarmChart;
